// extracted by mini-css-extract-plugin
export default {"documentsContainer":"InsuranceDocs_documentsContainer__pBkoS","cardsContainer":"InsuranceDocs_cardsContainer__qzQxO"};